
const InquiryMemoType = Symbol();

export class InquiryMemo {

    [InquiryMemoType]: any;
    readonly value: string;

    private constructor(
        value: string
    ) {
        this.value = value;
    }

    static fromString(value: string) {
        return new InquiryMemo(value);
    }
}
